import bdServices from '@/services/bd-services'

var FormData = require('form-data')

const nominaciones_tpaServices = {}

nominaciones_tpaServices.guardarNom_Mensual = async function (id, unidadNeg, year, mes, nominacion) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('unidadNeg', unidadNeg)
  formData.append('year', year)
  formData.append('mes', mes)
  formData.append('nominacion', nominacion)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addRecepcion.php'
    url: '/servidores/tpa/sca/nominaciones/guardarNominacionMensual.php'
  }
  const data = await bdServices(options) 
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data 
}

nominaciones_tpaServices.borrarNominacionMensual = async function (id) {
  let formData = new FormData()
  formData.append('id', id)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addRecepcion.php'
    url: '/servidores/tpa/sca/nominaciones/borrarNominacionMensual.php'
  }
  const data = await bdServices(options) 
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data 
}

nominaciones_tpaServices.obtenerNominacionesMes = async function (fechaI, fechaF, uN) {
  const data = await bdServices(`/servidores/tpa/sca/nominaciones/getNominaciones_Mes.php?feI=${fechaI}&feF=${fechaF}&uN=${uN}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

nominaciones_tpaServices.obtenerNominaciones_Porcentajes = async function (fecha) {
  const data = await bdServices(`/servidores/tpa/sca/nominaciones/getNominaciones_Porcentaje.php?fecha=${fecha}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

nominaciones_tpaServices.getNominacionesMensual = async function (fechaI, fechaF, uN) {
  const data = await bdServices(`/servidores/tpa/sca/nominaciones/getNominacionesMensuales.php`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

nominaciones_tpaServices.obtenerNominacionFecha = async function (fecha) {
  const data = await bdServices(`/servidores/tpa/sca/nominaciones/getNominaciones_Fecha.php?fe=${fecha}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

nominaciones_tpaServices.guardarNom_Diaria = async function (id, unidadNeg, nominacion, fechaNom) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('unidadNeg', unidadNeg)
  formData.append('nominacion', nominacion)
  formData.append('fechaNom', fechaNom)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/nominaciones/guardarNominacionDiaria.php'
  }
  const data = await bdServices(options) 
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data 
}

nominaciones_tpaServices.updateNewNominacion = async function (empresa, nominacion, fechaNom) {
  let formData = new FormData()
  formData.append('empresa', empresa)
  formData.append('nominacion', nominacion)
  formData.append('fechaNom', fechaNom)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/nominaciones/updateNewNominacion.php'
  }
  const data = await bdServices(options) 
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data 
}

nominaciones_tpaServices.guardarCambioNominacion = async function (unidadNeg, valorAnt, valorNuevo, id_usuario, nombre__usuario, fecha_registro) {
  let formData = new FormData()
  formData.append('uN', unidadNeg)
  formData.append('vA', valorAnt)
  formData.append('vN', valorNuevo)
  formData.append('idU', id_usuario)
  formData.append('nU', nombre__usuario)
  formData.append('fR', fecha_registro)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/nominaciones/guardarCambio_Nominacion.php'
  }
  const data = await bdServices(options) 
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data 
}

nominaciones_tpaServices.obtenerNominacionPeriodo = async function (anio, mes, primerDia, ultimoDia) {
  const data = await bdServices(`/servidores/tpa/sca/nominaciones/getNominacionMensual_Periodo.php?y=${anio}&m=${mes}&pDia=${primerDia}&uDia=${ultimoDia}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

export default nominaciones_tpaServices


// WEBPACK FOOTER //
// ./src/services/sca/nominaciones/nominacionesTpa.js